
import { required } from 'vuelidate/lib/validators'

export default {
  agenda: {
    professional: {
      id: {

      }
    },
    speciality: {
      id: {
        required
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/validations.js